import { useCallback } from "react";
import useRazorpay from "react-razorpay";
import { useSelector } from "react-redux";
import Button from "./Button";

export default function Payment({onSubmit=()=>{},amount,title}) {
  const {data} = useSelector(state=>state.userinfo)
  const Razorpay = useRazorpay();
  const handlePayment = useCallback(() => {
    const options: RazorpayOptions = {
      key: "rzp_test_ByXEJjNYN3hIRy",
      amount: parseFloat(amount) * 100,
      currency: "INR",
      name: "Aamod",
      // description: "Test Transaction",
      image: "https://example.com/your_logo",
      handler: (res) => {
        onSubmit(res);
      },
      prefill: {
        name: data?.name,
        email: data?.email,
        contact: data?.mobile,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  }, [Razorpay]);

  return (
    <div className="App">
      <Button backgroundColor={'#219653'} onClick={handlePayment} title={title} />
    </div>
  );
}